import React from "react";
import { Award, ArrowUpRight } from "lucide-react";
import { DiamondBorder, SectionLabel } from "./AipanPattern";
import { HIGHLIGHTS, IMAGES } from "../mock";

export default function Highlights() {
  return (
    <section className="py-24 pb-4 bg-[var(--paper)] -mt-[65px]">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-12 gap-12 items-center">
          <div className="lg:col-span-5 relative">
            <div className="relative rounded-[28px] overflow-hidden aspect-[4/3] shadow-2xl border-[6px] border-white">
              <img src={IMAGES.students2} alt="University students" className="h-full w-full object-cover" />
              <div className="absolute inset-0 bg-gradient-to-t from-[var(--terracotta-deep)]/70 to-transparent" />
              <div className="absolute bottom-6 left-6 right-6 text-[hsl(0,72%,52%)]">
                {/* <div className="font-serif italic text-[13px] opacity-90">The Student Body</div>
                <div className="font-display text-[24px] leading-tight">Over a lakh dreams, one campus family.</div> */}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <SectionLabel>Recognitions & Milestones</SectionLabel>
            <h2 className="mt-5 font-display text-[38px] lg:text-[48px] leading-[1.05] font-bold">
              A record we are <span className="italic text-[var(--terracotta)]">quietly proud</span> of.
            </h2>
            <DiamondBorder className="my-2 max-w-md" />

            <ul className="space-y-3">
              {HIGHLIGHTS.map((h, i) => (
                <li key={i} className="group flex items-start gap-1 rounded-xl px-0 py-0 hover:bg-[var(--cream)] transition-colors">
                  <div className="shrink-0 h-6 w-6 rounded-lg bg-[var(--saffron)]/15 grid place-items-center border border-[var(--saffron)]/30">
                    <Award size={16} className="text-[var(--saffron)]" />
                  </div>
                  <p className="text-[14.5px] leading-relaxed text-[var(--ink)]/85 pt-1">{h}</p>
                </li>
              ))}
            </ul>

            <div className="mt-7">
              <a href="https://ukadmission.samarth.ac.in/" className="btn-primary">Apply Online <ArrowUpRight size={16} /></a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
